<p-fieldset [legend]="titulo">
  <div class="row">
    <div class="col-12">
      <button (click)="adicionar()" class="btn btn-sm btn-outline-primary" [disabled]="itemAtual">
        <i class="fa fa-plus"></i> Adicionar
      </button>
    </div>
  </div>
  <table class="table table-eddy table-sm">
    <thead>
      <tr>
        <th style="width: 15%" scope="col">CPF</th>
        <th style="width: 40%" scope="col">Nome</th>
        <th style="width: 30%" scope="col">E-mail Profissional/Pessoal</th>
        <th style="width: 5%" scope="col">Assinou</th>
        <th style="width: 10%" scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of entidade[campo]">
        <td *ngIf="item.editavel" style="width: 55%" [attr.colspan]="'2'">
          <p-autoComplete [(ngModel)]="item.pessoa" [field]="pessoaAutoComplete.conversor"
            [suggestions]="pessoaAutoComplete.lista" (completeMethod)="pessoaAutoComplete.filtrar($event)"
            inputStyleClass="form-control autocomplete-radius-right" minLength="2"
            (onSelect)="callbackPessoa(item.pessoa)" [style]="{ width: 'calc(100% - 46px)', float: 'left' }"
            [forceSelection]="true" [autoHighlight]="true" *ngIf="pessoaAutoComplete">
            <ng-template let-pessoa pTemplate="item">
              {{pessoa.cpf_cnpj | CPF}} {{pessoa.nome}}
            </ng-template>
          </p-autoComplete>
          <button class="btn btn-outline-secondary float-right" type="button" (click)="cadastroPessoa()"
            style="height: 36px; border-bottom-left-radius: 0px;  border-top-left-radius: 0px;">
            <i class="fa fa-user-plus"></i>
          </button>
        </td>

        <td style="width: 15%" *ngIf="!item.editavel">
          <span>{{item.CPF | CPF}}</span>
        </td>
        <td style="width: 40%" *ngIf="!item.editavel">
          <span>{{item.Nome}}</span>
        </td>

        <td style="width: 30%">
          <span class="d-block">{{item.EmailProfissional}}</span>
          <span class="d-block">{{item.EmailPessoal}}</span>
        </td>

        <td style="width: 5%">
          <span *ngIf="!item.editavel">{{item.AssinouContrato}}</span>
          <p-selectButton *ngIf="item.editavel" [options]="opcoesSimNao" optionValue="id"
            [(ngModel)]="itemAtual.AssinouContrato" [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
        </td>

        <td style="width: 10%" class="text-right">
          <button *ngIf="!item.editavel" (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
          </button>
          <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
          </button>
          <button *ngIf="item.editavel" (click)="salvar()" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
          </button>
          <button *ngIf="item.editavel" (click)="cancelar()" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</p-fieldset>
<lib-pessoa-cadastro-dlg *ngIf="itemAtual" [entity]="itemAtual['pessoa']" (callback)="callbackPessoa($event)"
  [login]="login"></lib-pessoa-cadastro-dlg>